import { Play } from "@phosphor-icons/react";
import type { FeaturePalette } from "@/shared/components/command-palette/types";

export const relationalPalette: FeaturePalette = {
  commands: [
    {
      id: "relational.start",
      title: "Start relational reasoning block",
      icon: Play,
      scopeId: "relational",
      keywords: ["relational", "reasoning", "rft", "smart", "logic", "train"],
      run: (ctx) => ctx.router.push("/relational"),
    },
  ],
};
